// THE PERIOD AS ONE BUTTON (UI rebuild batch 2) — Astra's date control beside Filters: the button names the window
// (today's Dubai date when the window is today, else the period's words), and a tap opens today's PeriodChips — the one
// period selector, with its Dates… boxes and All time — on a line beneath the bar. Picking a named period closes it.
import { CalendarDays } from 'lucide-react';
import { PeriodChips, periodWords, type PeriodValue } from '../../PeriodChips';
import { fmtDay } from '../../../lib/format';

export function periodLabel(v: PeriodValue): string {
  if (v.key === 'today') return fmtDay(Date.now());   // "26 Oct" — no current year (HOUSE-STYLE rule 11)
  if (v.key === 'custom') {
    if (v.from && v.to) return `${fmtDay(`${v.from}T12:00:00+04:00`)} – ${fmtDay(`${v.to}T12:00:00+04:00`)}`;
    if (v.from) return `From ${fmtDay(`${v.from}T12:00:00+04:00`)}`;
    if (v.to) return `To ${fmtDay(`${v.to}T12:00:00+04:00`)}`;
  }
  const w = periodWords(v);
  return w.charAt(0).toUpperCase() + w.slice(1);
}

export function PeriodButton({ value, open, onToggle }: { value: PeriodValue; open: boolean; onToggle: () => void }) {
  return (
    <button type="button" aria-expanded={open} onClick={onToggle} className="btn-secondary whitespace-nowrap px-3 text-body max-lg:flex-1">
      <CalendarDays className="h-4 w-4 text-tg-hint" aria-hidden />{periodLabel(value)}
    </button>
  );
}

export function PeriodPanel({ value, onChange, onDone }: { value: PeriodValue; onChange: (v: PeriodValue) => void; onDone: () => void }) {
  return (
    <div className="mb-4 rounded-[10px] border border-stroke bg-panel p-3">
      <PeriodChips
        value={value}
        allTime
        onChange={(v) => { onChange(v); if (v.key !== 'custom') onDone(); }}
      />
    </div>
  );
}
